<template>
	<v-app>
		<Loading></Loading>
		<Snackbar></Snackbar>
		<template v-if="isStandaloneHost">
			<router-view />
		</template>
		<template v-else>
			<navigation v-if="getAutenticate"></navigation>
			<toolbar v-if="getAutenticate"></toolbar>

			<div :class="['router-wrapper', { blurred: getLicenseExpired }]">
				<router-view />
			</div>

			<template v-if="getAutenticate">
				<v-dialog v-model="showModal" persistent max-width="500" value="true">
					<v-card>
						<v-card-title class="headline red--text">Licenza scaduta</v-card-title>
						<v-card-text>
							La licenza di utilizzo del software è scaduta. Per continuare a usare il servizio, è necessario rinnovarla.<br /><br />
							Se necessario, contatta l’assistenza per ricevere supporto.
						</v-card-text>
						<v-card-actions class="justify-center">
							<v-btn color="primary" @click="logout">Logout</v-btn>
							<!-- Nessun bottone: l'utente non può fare nulla -->
						</v-card-actions>
					</v-card>
				</v-dialog>
				<message></message>
			</template>
		</template>
	</v-app>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import Loading from '@/components/core/Loading';
import Snackbar from '@/components/core/Snackbar';
export default {
	name: 'App',
	components: { Loading, Snackbar },
	data() {
		return {};
	},
	methods: {
		...mapMutations({
			setPreload: 'settings/setPreload',
			setSetting: 'settings/setSetting',
		}),
		...mapActions({
			setLogout: 'profile/logout',
		}),
		async logout() {
			await this.setLogout();
			await this.setSetting({});
			this.$router.push('/login');
		},
	},
	computed: {
		...mapGetters({
			getAutenticate: 'profile/getAutenticate',
			getLicenseExpired: 'profile/getLicenseExpired',
		}),
		isPartnerHost() {
			const onHost = typeof window !== 'undefined' && (window.location.hostname === 'partner.azseller.app' || window.location.hostname === 'devpartner.azseller.app');
			const onRoute = this.$route && this.$route.meta && this.$route.meta.partnerHost;
			return !!(onHost || onRoute);
		},
		isAffiliateHost() {
			const onHost =
				typeof window !== 'undefined' && (window.location.hostname === 'affiliate.azseller.app' || window.location.hostname === 'devaffiliate.azseller.app');
			const onRoute = this.$route && this.$route.meta && this.$route.meta.affiliateHost;
			return !!(onHost || onRoute);
		},
		// le aree riservate hanno un layout proprio: niente navigation, toolbar o dialog licenza
		isStandaloneHost() {
			return this.isPartnerHost || this.isAffiliateHost;
		},
		showModal() {
			return this.getLicenseExpired;
		},
	},
};
</script>

<style scoped>
.blurred {
	filter: blur(4px);
}
</style>
